module.exports = __webpack_public_path__ + "img/header-weddingRingsStylesElegant.06b4c65.webp";